import React, {useContext} from 'react';
import {LanguageContext} from "../languages/LanguageContext";
import {Link} from "react-router-dom";
import {FaFacebook} from "react-icons/fa";
import {HiArrowLongRight} from "react-icons/hi2";
import GalleryPreview from "./GalleryPreview";

const StaraZagora = () => {
	const { language, translations } = useContext(LanguageContext);
	return (
		<div className='important-container max-w flex jc-sb gap-2 w-full conference-container'>
			<div className='content-container flex gap-sm w-full jc-sb wrap'>
				<div className='flex wrap gap-sm'>
					<div className='wrapper'>
						<p>Erasmus+</p>
						<h3 dangerouslySetInnerHTML={{__html: translations[language]["conferenceTitle"]}}></h3>
						<Link to='https://www.facebook.com/reel/2887644914931857' target='_blank'>
							<button>
								<FaFacebook className='icon-btn'/>
								{translations[language]["watchVideo"]}
								<HiArrowLongRight className='icon-btn'/>
							</button>
						</Link>
					</div>
				</div>
				<div className='latest-news flex col'>
					<div className='news-video'>
						<video src='/videos/stara-zagora.mp4' controls muted playsInline preload='metadata'></video>
					</div>
					<GalleryPreview
						folder={'stara-zagora/'}
						imageCount={13}
						prefix={'stara-zagora-'}
						news={true}
					/>
				</div>
			</div>
		</div>
	);
};

export default StaraZagora;
